import { translation } from "../../helper/translation"

export const Footer = () => {
    return(
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <p>enginkaya.com © 1982 - {new Date().getFullYear()} <a href="/impressum">{translation('impressum')}</a> <a href="/privacy-policy">{translation('privacy-policy')}</a></p>
                    </div>
                </div>
            </div>
        </footer>
    )
}